import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { environment as env } from '../../environments/environment';
import { UserFactory } from './user.factory';
import { sha256 } from 'js-sha256';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from 'localize-router';
import { map } from "rxjs/operators";
import { SessionTimeoutService } from 'src/app/services/session-timeout.service';

@Injectable()
export class AuthenticationService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private userFactory: UserFactory,
    private translate: TranslateService,
    private localize: LocalizeRouterService,
    private sessionTimeoutService: SessionTimeoutService
  ) {

  }

  login(username: string, password: string): Observable<any> {
    return this.http
      .post<any>(env.apiEndpoint + '/auth/verifyUser', {
        userName: username, password: sha256(password)
      });
  }

  verifyForgotPassword(input?): Observable<any> {
    // todo call service
    return this.http.post<any>(env.apiEndpoint + '/auth/verifyUser4Reset', input);
  }

  getOtp(sessionId: string): Observable<any> {
    // todo call service
    return this.http.post<any>(env.apiEndpoint + '/auth/getOtp/' + sessionId, {});
  }

  getConfAuthen(): Observable<any> {
    return this.http.post<any>(env.apiEndpoint + '/auth/getConfAuthen', {});
  }
  resendOtp(): Observable<any> {
    // todo call service
    return this.http.post<any>(env.apiEndpoint + '/auth/resendOtp', this.userFactory.getForgetForm()['form']);
  }

  verifyOtp(otp: string, key: string): Observable<any> {
    // todo call service
    return this.http.post<any>(env.apiEndpoint + '/auth/verifyOtp', { otp: otp, key: key });
  }

  changePassword(userName: string, password: string, newPassword: string): Observable<any> {
    return this.http.post<any>(env.apiEndpoint + '/auth/changePassword'
      , { userName: userName, password: sha256(password), newPassword: sha256(newPassword) });
  }

  resetPassword(data: any): Observable<any> {
    return this.http.post<any>(env.apiEndpoint + '/auth/resetPassword', data);
  }

  getAgentProfile(): Observable<any> {
    return this.http.post<any>(env.apiEndpoint + '/auth/getAgentProfile', {}).pipe(map((response) => {
      const agentProfile = response;
      agentProfile.agentProfileDetail.email = agentProfile.agentProfileDetail.email != null
        ? atob(response.agentProfileDetail.email) : '-';
      return agentProfile;
    }));
  }

  getTokenExpiredDate(): Observable<any> {
    return this.http.post<any>(env.apiEndpoint + '/auth/getTokenExpiredDate', {});
  }

  refreshToken(): Observable<any> {
    return this.http.post<any>(env.apiEndpoint + '/auth/refresh-token', {
      token: this.userFactory.getToken()
    });
  }

  logout() {
    this.userFactory.signOut();

    this.sessionTimeoutService.stopTokenExpiredClock();

    if (env.isSso) {
      const urlLogoutWithADB2C = `${env.logoutUrl}`;
      console.log('url: ', urlLogoutWithADB2C);
      this.clearSeesion();
      window.location.href = urlLogoutWithADB2C;
    } else {
      const translatedPath: any = this.localize.translateRoute('/login');
      this.clearSeesion();
      this.router.navigate([translatedPath]);
    }
  }

  removeToken(){
    this.userFactory.signOut();

    this.sessionTimeoutService.stopTokenExpiredClock();
  }

  clearSeesion(){
    sessionStorage.clear();

    // Preserve specific keys before clearing localStorage
    const preservedKeys: { [key: string]: string } = {};
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('news_popup_read_') || key === 'LOCALIZE_DEFAULT_LANGUAGE') {
        preservedKeys[key] = localStorage.getItem(key);
      }
    });

    try { localStorage.clear(); } catch (error) { console.error('Failed to clear localStorage:', error); }

    // Restore preserved keys
    Object.keys(preservedKeys).forEach(key => {
      localStorage.setItem(key, preservedKeys[key]);
    });
  }

  logoutJwt(): Observable<any> {
    return this.http.get<any>(env.apiEndpoint + '/auth/logout');
  }

  getCurrentUserProfile() {
    if (this.isAuthenticated()) {
      return this.userFactory.getProfile();
    }
    return undefined;
  }

  getAuthToken(): string {
    if (this.isAuthenticated()) {
      return this.userFactory.getToken();
    }
    return undefined;
  }

  isAuthenticated(): boolean {
    return !!this.userFactory.getToken();
  }

  getUserFactory(): UserFactory {
    return this.userFactory;
  }
}
